import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-semibold" }, "Modifier la publication")
], -1)
const _hoisted_3 = { class: "card-body p-25" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Titre *", -1)
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Auteur *", -1)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Catégorie *", -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Année *", -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Éditeur *", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Nouvelle image (optionnel)", -1)
const _hoisted_17 = {
  key: 0,
  class: "col-md-12 mt-3"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "col-md-12 mt-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Contenu", -1)
const _hoisted_21 = { class: "col-md-12 mt-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-success" }, "Modifier", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_Form, {
            key: 0,
            "initial-values": _ctx.initialValues,
            onSubmit: _ctx.updatePublication,
            "validation-schema": _ctx.publicationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Field, {
                    name: "titre",
                    class: "form-control"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "titre",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Field, {
                    name: "auteur",
                    class: "form-control"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "auteur",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Field, { name: "categoriepublication" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, {
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                        options: _ctx.categorieOptions
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Field, {
                    name: "annepublication",
                    type: "number",
                    class: "form-control"
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_Field, {
                    name: "editeur",
                    class: "form-control"
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("input", {
                    type: "file",
                    class: "form-control",
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageChange && _ctx.onImageChange(...args)))
                  }, null, 32)
                ]),
                (_ctx.currentImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: _ctx.getUrlApiForFiles(_ctx.currentImage),
                        style: {"height":"150px","border-radius":"12px"}
                      }, null, 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_QuillEditor, {
                    ref: "contenuEditor",
                    content: _ctx.contenu,
                    "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contenu) = $event)),
                    "content-type": "html",
                    theme: "snow",
                    toolbar: "full"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_router_link, {
                    to: "/listPublication",
                    class: "btn btn-danger ms-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Annuler ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["initial-values", "onSubmit", "validation-schema"]))
        : _createCommentVNode("", true)
    ])
  ]))
}